var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-listing"},[(_vm.featuredEvent)?_c('FeaturedEvent',{attrs:{"event":_vm.featuredEvent}}):_vm._e(),_vm._v(" "),_c('EventFilters'),_vm._v(" "),_c('Listing',{attrs:{"title":"","events":_vm.filteredEvents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }